import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Corrigindo o ícone do marcador
const customIcon = new L.Icon({
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  shadowSize: [41, 41],
});

const Map = () => {
  const [coordinates, setCoordinates] = useState([]);

  // Buscar coordenadas do backend com fetch
  useEffect(() => {
    const fetchCoordinates = async () => {
      try {
        const response = await fetch("https://api.hub4food.colab4food.com/api/entities/coords/coordinates");
        if (!response.ok) {
          throw new Error("Erro ao buscar coordenadas");
        }
        const data = await response.json();
        setCoordinates(data);
      } catch (err) {
        console.error("Erro ao buscar coordenadas:", err);
      }
    };

    fetchCoordinates();
  }, []);

  return (
    <MapContainer center={[41.332101312991426, -8.685826289517397]} zoom={8} style={{ height: "350px", width: "1000px" }}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      
      {/* Renderizar markers dinamicamente */}
      {coordinates.map((entity) => (
        <Marker 
          key={entity.id} 
          position={[entity.latitude_cords, entity.longitude_cords]} 
          icon={customIcon}
        >
          <Popup>
            <div>
              <h3>{entity.name}</h3>
              <button onClick={() => window.location.href = `/detailedentities/${entity.id}`}>
                See Details
              </button>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default Map;
